import axios from 'axios';
import $i18n from '@/i18n';
const i18n: any = $i18n.global;

const AUTO_TOPUP_STATUS_ERROR = -1;

// timeout for AutoTopUp data = 60sec in ms
const AUTO_TOPUP_DATA_TIMEOUT = 60000;
export default {
  namespaced: true,
  state: {
    inProgress: false,
    status: null,
    errorMessage: null,
    lastUpdate: new Date(0)
  },
  mutations: {
    setErrorMessage(state: any, newErrorMessage: String) {
      state.errorMessage = newErrorMessage;
    },
    setStatus(state:any, newStatus: String) {
      state.lastUpdate = Date.now();
      state.errorMessage = null;
      state.status = newStatus;
    },
    setInProgress(state: any, newValue: boolean) {
      state.inProgress = newValue;
    },
    removeAutoTopupStatus(state: any) {
      state.status = null;
    }
  },
  getters: {
    inProgress(state: any) {
      return state.inProgress;
    },
    status(state: any) {
      return state.status;
    },
    errorMessage(state: any) {
      return state.errorMessage;
    },
    lastUpdate(state: any) {
      return state.lastUpdate;
    }
  },
  actions: {
    refreshAutoTopUpStatus(context: any, axios: any) {

      if (context.getters.status && (context.getters.lastUpdate + AUTO_TOPUP_DATA_TIMEOUT > Date.now())) {
        //there is no need to refresh autoTopupStatus
        return;
      } else {
        // we have outdated data, remove old one so we do not show it while loading new data
        context.commit("removeAutoTopupStatus");
      }

      context.commit("setInProgress", true);
      axios.get('api/user/autoTopup')
        .then(
          response => {
            if (response && response.data && response.data.autoTopupStatus) {
              let autoTopupStatus = response.data.autoTopupStatus;
              if(autoTopupStatus.status == AUTO_TOPUP_STATUS_ERROR) {
                context.commit("setErrorMessage", i18n.t("COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE"))
              }
              context.commit("setStatus", autoTopupStatus);
            } else {
              context.commit("setErrorMessage", i18n.t("COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE"));
            }
          }
        ).catch(
        () => {
          context.commit("setErrorMessage", i18n.t("COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE"));
        }
      ).finally(
        () => {
          context.commit("setInProgress", false);
        }
      )
    }
  }
}
